import { FormattedMessage } from 'react-intl';
import { FreshdeskFeedbackTicket } from 'library/types';
import { Box, Chip, Divider, Paper, Stack, Typography } from '@mui/material';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import ConfirmationNumberRoundedIcon from '@mui/icons-material/ConfirmationNumberRounded';

type TicketDetailsProps = {
  ticket: FreshdeskFeedbackTicket;
};

const TicketDetails = ({ ticket }: TicketDetailsProps) => (
  <Paper
    variant="outlined"
    sx={(theme) => ({
      p: { xs: 2, sm: 2.5 },
      borderRadius: 2.5,
      backgroundColor: theme.palette.action.hover,
    })}>
    <Stack spacing={2}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25} alignItems={{ xs: 'flex-start', sm: 'center' }}>
        <Chip
          size="small"
          icon={<ConfirmationNumberRoundedIcon />}
          label={
            <FormattedMessage
              id="ticketSurvey.ticketNumber"
              defaultMessage="Ticket #{ticketId}"
              values={{ ticketId: ticket.ticketId }}
            />
          }
          sx={{ flexShrink: 0, fontWeight: 700 }}
        />
        <Typography
          variant="subtitle1"
          component="h2"
          sx={{ minWidth: 0, fontWeight: 700, lineHeight: 1.4, overflowWrap: 'anywhere' }}>
          {ticket.subject || '—'}
        </Typography>
      </Stack>

      <Divider />

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 1.5, sm: 4 }}>
        <Stack direction="row" spacing={1.25} alignItems="center" sx={{ minWidth: 0, flex: 1 }}>
          <Box
            sx={(theme) => ({
              display: 'grid',
              flexShrink: 0,
              width: 36,
              height: 36,
              placeItems: 'center',
              borderRadius: 1.5,
              color: 'primary.main',
              backgroundColor: theme.palette.action.selected,
            })}>
            <PersonOutlineRoundedIcon fontSize="small" aria-hidden="true" />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="caption" color="text.secondary" display="block">
              <FormattedMessage id="ticketSurvey.requester" defaultMessage="Talep sahibi" />
            </Typography>
            <Typography variant="body2" fontWeight={600} sx={{ overflowWrap: 'anywhere' }}>
              {ticket.requesterName || '—'}
            </Typography>
          </Box>
        </Stack>

        <Stack direction="row" spacing={1.25} alignItems="center" sx={{ minWidth: 0, flex: 1 }}>
          <Box
            sx={(theme) => ({
              display: 'grid',
              flexShrink: 0,
              width: 36,
              height: 36,
              placeItems: 'center',
              borderRadius: 1.5,
              color: 'primary.main',
              backgroundColor: theme.palette.action.selected,
            })}>
            <SupportAgentRoundedIcon fontSize="small" aria-hidden="true" />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="caption" color="text.secondary" display="block">
              <FormattedMessage id="ticketSurvey.responder" defaultMessage="Destek uzmanı" />
            </Typography>
            <Typography variant="body2" fontWeight={600} sx={{ overflowWrap: 'anywhere' }}>
              {ticket.responderName || '—'}
            </Typography>
          </Box>
        </Stack>
      </Stack>
    </Stack>
  </Paper>
);

export default TicketDetails;
